import { render, staticRenderFns } from "./CardSolicitacaoDadosBasicos.vue?vue&type=template&id=1a5cb136"
import script from "./CardSolicitacaoDadosBasicos.vue?vue&type=script&lang=js"
export * from "./CardSolicitacaoDadosBasicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports